const version = "0.1.18";

export default version;
